import { render, staticRenderFns } from "./MasterBoxes.vue?vue&type=template&id=3501577a&scoped=true&"
import script from "./MasterBoxes.vue?vue&type=script&lang=js&"
export * from "./MasterBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3501577a",
  null
  
)

export default component.exports